export default __webpack_public_path__ + "2b272a7cf6cde5d9d3352ddff7bafac9.svg";